<template>
  <div>
    <v-list>
      <v-row class="mx-0">
        <v-col class="d-flex align-center">
          <span class="mainTitle mr-auto">Product Commission</span>
          <div class="d-flex align-center">
            <v-select
              dense
              hide-details="auto"
              style="max-width: 150px"
              outlined
              v-model="ProductSelectedMonthYear"
              :items="ProductDateRange"
              @change="(ProductPageVal = 1), reloadProductList"
            />
          </div>
        </v-col>
      </v-row>
      <v-list-item>
        <v-list-item-content>
          <v-row justify="space-between">
            <v-col cols="1">
              <b>Payment Date</b>
            </v-col>
            <v-col cols="2">
              <b>Product</b>
            </v-col>
            <v-col cols="1">
              <b>Quantity</b>
            </v-col>
            <v-col cols="2">
              <b>Commission Amount</b>
            </v-col>
            <v-col cols="2">
              <b>Sale Amount</b>
            </v-col>
            <v-col cols="2">
              <b>Customer Name</b>
            </v-col>
            <v-col cols="2">
              <b>Transaction ID</b>
            </v-col>
          </v-row>
          <v-divider />
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-for="(item, index) in ProductList.docs" :key="`${index}${item._id}`">
        <v-list-item-content>
          <v-row justify="space-between">
            <v-col cols="1">{{ item.updated_at | moment('YYYY/MM/DD hh:mm') }}</v-col>
            <v-col cols="2">{{
              get(item, 'metadata.BNPhysicalProductOrder.items.product.name', null) ||
              get(item, 'metadata.BNBooking.purchasedProducts.product.name', '-')
            }}</v-col>
            <v-col cols="1">{{
              get(item, 'metadata.BNPhysicalProductOrder.items.qty', null) ||
              get(item, 'metadata.BNBooking.purchasedProducts.qty', 0)
            }}</v-col>
            <v-col cols="2">
              ${{
                round(
                  get(
                    item,
                    'metadata.BNPhysicalProductOrder.items.commission.amountPayable',
                    null,
                  ) ||
                    get(item, 'metadata.BNBooking.purchasedProducts.commission.amountPayable', 0),
                  0,
                ) | toThousandFilter
              }}
            </v-col>
            <v-col cols="2">
              ${{
                round(
                  get(item, 'metadata.BNPhysicalProductOrder.items.subtotal', null) ||
                    get(item, 'metadata.BNBooking.purchasedProducts.subTotal', 0),
                  0,
                ) | toThousandFilter
              }}
            </v-col>
            <v-col cols="2">{{ get(item, 'owner.name', '-') }}</v-col>
            <v-col cols="2">
              {{ item.sid || '-' }}
            </v-col>
          </v-row>
          <v-divider />
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="!ProductList || !ProductList.total" class="text-center">
        <v-row>
          <v-col> No Data </v-col>
        </v-row>
      </v-list-item>
      <div v-else class="mx-3">
        <table class="float-right">
          <tbody>
            <tr>
              <td class="text-right mainTitle">Commission Total HK$</td>
              <td class="text-right">
                {{ round(ProductList.totalCommissionAmount, 0) | toThousandFilter }}
              </td>
            </tr>
            <tr>
              <td class="text-right mainTitle">Sales Total HK$</td>
              <td class="text-right">
                {{ round(ProductList.totalSaleAmount, 0) | toThousandFilter }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <v-pagination
        class="mt-4"
        v-model="ProductPageVal"
        :total-visible="10"
        :length="ProductList.pages || 1"
      />
    </v-list>
    <v-list>
      <v-row class="ml-0 mr-0">
        <v-col class="d-flex align-center">
          <span class="mainTitle mr-auto">Ticket Package Commission</span>
          <div class="d-flex align-center">
            <v-select
              dense
              hide-details="auto"
              style="max-width: 150px"
              outlined
              v-model="PackageSelectedMonthYear"
              :items="PackageDateRange"
              @change="(TicketPackagePageVal = 1), reloadTicketPackageList"
            />
          </div>
        </v-col>
      </v-row>
      <v-list-item>
        <v-list-item-content>
          <v-row justify="space-between">
            <v-col cols="1">
              <b>Payment Date</b>
            </v-col>
            <v-col cols="2">
              <b>Package</b>
            </v-col>
            <v-col cols="1">
              <b>Quantity</b>
            </v-col>
            <v-col cols="2">
              <b>Commission Amount</b>
            </v-col>
            <v-col cols="2">
              <b>Sale Amount</b>
            </v-col>
            <v-col cols="2">
              <b>Customer Name</b>
            </v-col>
            <v-col cols="2">
              <b>Transaction ID</b>
            </v-col>
          </v-row>
          <v-divider />
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-for="item in TicketPackageList.docs" :key="item._id">
        <v-list-item-content>
          <v-row justify="space-between">
            <v-col cols="1">{{ item.updated_at | moment('YYYY/MM/DD hh:mm') }}</v-col>
            <v-col cols="2">{{ get(item, 'metadata.BNTicketsPackage.product.name', '-') }}</v-col>
            <v-col cols="1">{{ get(item, 'metadata.BNTicketsPackage.quota', 0) }}</v-col>
            <v-col cols="2">
              ${{
                round(get(item, 'metadata.BNTicketsPackage.commission.amountPayable', 0), 0)
                  | toThousandFilter
              }}
            </v-col>
            <v-col cols="2">
              ${{
                round(get(item, 'metadata.BNTicketsPackage.amountPayable', 0), 0) | toThousandFilter
              }}
            </v-col>
            <v-col cols="2">{{ get(item, 'owner.name', '-') }}</v-col>
            <v-col cols="2">
              {{ item.sid || '-' }}
            </v-col>
          </v-row>
          <v-divider />
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="!TicketPackageList || !TicketPackageList.total" class="text-center">
        <v-row>
          <v-col> No Data </v-col>
        </v-row>
      </v-list-item>
      <div v-else class="mx-3">
        <table class="float-right">
          <tbody>
            <tr>
              <td class="text-right mainTitle">Commission Total HK$</td>
              <td class="text-right">
                {{ round(TicketPackageList.totalCommissionAmount, 0) | toThousandFilter }}
              </td>
            </tr>
            <tr>
              <td class="text-right mainTitle">Sales Total HK$</td>
              <td class="text-right">
                {{ round(TicketPackageList.totalSaleAmount, 0) | toThousandFilter }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <v-pagination
        class="mt-4"
        v-model="TicketPackagePageVal"
        :total-visible="10"
        :length="TicketPackageList.pages || 1"
      />
    </v-list>
  </div>
</template>

<script>
import { paymentStatus } from '@/data/constants';
import { crudList } from '@/api/crud';
import api from '@/api';
import { get, round } from 'lodash';
import moment from 'moment';

export default {
  name: 'CommissionDetails',
  props: {
    id: String,
  },
  data() {
    return {
      paymentStatus,
      ProductList: {},
      TicketPackageList: {},
      ProductPage: 1,
      TicketPackagePage: 1,
      limit: 5,
      populate: { path: 'owner', select: 'name' },
      ProductDateRange: [],
      ProductSelectedMonthYear: null,
      PackageDateRange: [],
      PackageSelectedMonthYear: null,
    };
  },
  computed: {
    TicketPackagePageVal: {
      get() {
        return this.TicketPackageList.page;
      },
      set(val) {
        this.TicketPackagePage = val;
        this.reloadTicketPackageList();
      },
    },
    ProductPageVal: {
      get() {
        return this.ProductList.page;
      },
      set(val) {
        this.ProductPage = val;
        this.reloadProductList();
      },
    },
  },
  watch: {
    id: {
      immediate: true,
      handler(v) {
        if (v) {
          this.reload();
        }
      },
    },
  },
  methods: {
    get,
    round,
    async reload() {
      await this.getDateRanges();
      this.reloadProductList();
      this.reloadTicketPackageList();
    },
    async getDateRanges() {
      if (!this.id) return;

      const ProductCommissionDates = await crudList(
        api,
        `bn/admin/PhysicalProduct/staff/${this.id}/commission/dates`,
      );

      if (ProductCommissionDates?.length > 0) {
        this.ProductDateRange = ProductCommissionDates?.map(x => ({
          text: moment(x).format('MMM YYYY'),
          value: x,
        }));
        this.ProductSelectedMonthYear = this.ProductDateRange?.[0]?.value;
      }

      const PackageCommissionDates = await crudList(
        api,
        `bn/admin/TicketsPackage/staff/${this.id}/commission/dates`,
      );

      if (PackageCommissionDates?.length > 0) {
        this.PackageDateRange = PackageCommissionDates?.map(x => ({
          text: moment(x).format('MMM YYYY'),
          value: x,
        }));
        this.PackageSelectedMonthYear = this.PackageDateRange?.[0]?.value;
      }
    },
    async reloadProductList() {
      if (!this.id) return;

      this.ProductList = await crudList(
        api,
        `bn/admin/PhysicalProduct/staff/${this.id}/commission/${this.ProductSelectedMonthYear}`,
        {
          page: this.ProductPage,
          limit: this.limit,
          populate: this.populate,
        },
      );
    },
    async reloadTicketPackageList() {
      if (!this.id) return;

      this.TicketPackageList = await crudList(
        api,
        `bn/admin/TicketsPackage/staff/${this.id}/commission/${this.PackageSelectedMonthYear}`,
        {
          page: this.TicketPackagePage,
          limit: this.limit,
          populate: this.populate,
        },
      );
    },
  },
};
</script>
